import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addApplyWFH, WFHDashboardBalenceCount } from "./WfhSerevice";
import { getTrans as T } from "../../../../Shared/Language";
import TosterService from "../../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../../App";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import WfhManagerReport from "./WfhCommon/WfhManagerReport";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import WfhNavBarItems from "./WfhCommon/WfhNavBarItems";
import { setLeaveRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { useDispatch } from "react-redux";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

function WfhDashboard() {
  const [checkedHalfDay, setCheckedHalfDay] = useState(false);
  const [showHalfDay, setShowHalfDay] = useState(true);
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [dateError, setDateError] = useState(false);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [WFHCountType, setWFHCountType] = useState([]);
  const history = useHistory();
  let days;
  const dispatch = useDispatch();
  let halfPreferences = "";

  let minimumDate = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7)
    ?.toISOString()
    ?.split("T")[0];

  const { showLoading, hideLoading } = useContext(LoaderContext);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [read, setRead] = useState(false);
  const [adjustment, setAdjustment] = useState(false);

  useEffect(() => {
    getWFHCount();
    permissionAccouncementList();

    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
    const dd = String(date.getDate()).padStart(2, "0");
    requestWfhForm.setFieldValue("startDate", `${yyyy}-${mm}-${dd}`);
    requestWfhForm.setFieldValue("endDate", `${yyyy}-${mm}-${dd}`);
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Leave.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Leave.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Leave.Delete") {
        setDeleted(true);
      } else if (UserPermission.PermissionName == "Leave.Read") {
        setRead(true);
      } else if (UserPermission.PermissionName == "Leave.Adjustment") {
        setAdjustment(true);
      }
    });
  };

  async function getWFHCount() {
    setIsloading(true);
    const param = {
      EmpId: userDetails?.EmpId,
      TypeId: 0,
    };
    try {
      const data = await WFHDashboardBalenceCount(param);
      let projectDetailData = await data;
      setWFHCountType(projectDetailData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  const requestWfhValidation = Yup.object().shape({
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
    reason: Yup.string().required("Reason is required"),
    isHalfDay: Yup.string(),
    halfPreference: Yup.string(),
  });

  const requestWfhForm = useFormik({
    initialValues: {
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      reason: "",
      isHalfDay: "",
      halfPreference: "",
    },
    validationSchema: requestWfhValidation,
    onSubmit: async (data) => {
      showLoading(true);
      const startDate = new Date(data?.startDate);
      const endDate = new Date(data?.endDate);
      if (startDate && endDate) {
        let Sdate = new Date(startDate);
        let Edate = new Date(endDate);
        let diffDate = Edate.getTime() - Sdate.getTime();
        days = diffDate / (1000 * 60 * 60 * 24);
      }
      let halfPreferences = "";
      if (showHalfDay == false) {
        halfPreferences = "";
      } else {
        halfPreferences = data?.halfPreference ? "Second Half" : "First Half";
      }
      const param = {
        OrgId: userDetails?.OrgId,
        EmpId: userDetails?.EmpId,
        BranchId: userDetails?.BranchId,
        LoggedInEmpId: userDetails?.EmpId,
        Reason: data?.reason,
        StartDate: startDate,
        EndDate: endDate,
        IsHalfDay: checkedHalfDay,
        HalfPreference: halfPreferences,
        WFHStatusId: 103,
      };
      if (startDate > endDate) {
        setDateError(true);
        setIsloading(false);
        return;
      }
      try {
        let applyLeaveResponse = await addApplyWFH(param);
        if (applyLeaveResponse?.StatusCode === 2000) {
          GetMasterSystemAlertList("Wfh_Added", 0);
          requestWfhForm.resetForm();
          dispatch(setLeaveRequestData(param));
          history.push("/MyWfh");
          setShowHalfDay(false);
        } else {
          const message =
            applyLeaveResponse?.StatusCode != 2000
              ? applyLeaveResponse?.Message
              : "Something went wrong";
          toster.current.warn(message);
          // setShowHalfDay(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        // setShowHalfDay(false);
      } finally {
        setIsloading(false);
      }
    },
  });

  const setStartDate = (event) => {
    const selectedStartDate = new Date(event);

    const currentEndDate = new Date(requestWfhForm.values.endDate);

    if (selectedStartDate >= currentEndDate) {
      requestWfhForm.setFieldValue(
        "endDate",
        selectedStartDate.toISOString().split("T")[0]
      );
      setDateError(false);
      setCheckedHalfDay(false);
      halfPreferences = "";
    }
  };

  const setEndDate = (event) => {
    const startDate = new Date(requestWfhForm.values.startDate);
    const endDate = new Date(event);
    const normalizeDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);
    if (normalizedStartDate <= normalizedEndDate) {
      setDateError(false);
      setCheckedHalfDay(false);
      halfPreferences = "";
    } else {
      setDateError(true);
      setCheckedHalfDay(true);
    }
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  useEffect(() => {
    const { startDate, endDate } = requestWfhForm.values;
    if (startDate && endDate) {
      setShowHalfDay(startDate === endDate);
    }
    if (masterSystemAlertData.length > 0) {
      toster.current.success(masterSystemAlertData);
    }
  }, [
    requestWfhForm.values.startDate,
    requestWfhForm.values.endDate,
    masterSystemAlertData,
  ]);

  const scrolltoSubmit = useRef(null);
  const handleClick = () => {
    scrolltoSubmit?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center mb-3">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Work From Home Dashboard</h2>
            </div>
            <div className="rightside-tabs">
              <WfhNavBarItems />
            </div>
          </div>
          <div className="col-xl-8">
            <div className="row card-radius">
              <div className="col-xl-12">
                <div className="balance-section">
                  <div className="balance-header">
                    <div className="balance-title-wrap">
                      <div class="balance-icon-wrap">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                      </div>
                      <div>
                        <div class="balance-heading">WFH - Balance</div>
                        <div class="balance-sub">Take a breather — check your leave balance</div>
                      </div>
                    </div>
                    <a onClick={handleClick} className="apply-btn">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4"></path></svg> Apply WFH
                    </a>
                  </div>


                  <div className="balance-body">
                    <div className="leave-image">
                      <svg viewBox="0 0 120 130" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <ellipse cx="60" cy="115" rx="30" ry="8" fill="#e8e2f5" opacity=".5"></ellipse>

                        <rect x="52" y="90" width="10" height="22" rx="5" fill="#26a69a"></rect>
                        <rect x="58" y="90" width="10" height="22" rx="5" fill="#1a7a74"></rect>

                        <rect x="40" y="55" width="40" height="40" rx="14" fill="#671cc9"></rect>

                        <path d="M55 55 L60 65 L65 55" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity=".5"></path>

                        <path d="M40 68 Q20 60 10 58" stroke="#f7c5a8" stroke-width="8" stroke-linecap="round"></path>

                        <circle cx="10" cy="58" r="5" fill="#f7c5a8"></circle>

                        <path d="M80 65 Q96 50 102 38" stroke="#f7c5a8" stroke-width="8" stroke-linecap="round"></path>
                        <circle cx="102" cy="38" r="5" fill="#f7c5a8"></circle>

                        <circle cx="60" cy="36" r="20" fill="#f7c5a8"></circle>

                        <path d="M40 30 Q44 14 60 12 Q76 14 80 30 Q72 22 60 22 Q48 22 40 30Z" fill="#2d1a0e"></path>

                        <circle cx="53" cy="36" r="3" fill="#2d1a0e"></circle>
                        <circle cx="67" cy="36" r="3" fill="#2d1a0e"></circle>
                        <circle cx="54" cy="35" r="1" fill="#fff"></circle>
                        <circle cx="68" cy="35" r="1" fill="#fff"></circle>

                        <path d="M54 43 Q60 48 66 43" stroke="#2d1a0e" stroke-width="1.5" stroke-linecap="round" fill="none"></path>

                        <g transform="translate(94,18) rotate(-30)">
                          <path d="M0 0 L22 8 L0 16 L4 8 Z" fill="#ec4119"></path>
                          <path d="M0 16 L4 8 L22 8" stroke="#fff" stroke-width=".8" fill="none" opacity=".5"></path>
                        </g>

                        <path d="M98 38 Q88 32 78 28" stroke="#ec4119" stroke-width="1.5" stroke-dasharray="3 3" opacity=".5" stroke-linecap="round"></path>
                      </svg>
                    </div>
                    <div className="leave-types-grid center">
                      {WFHCountType?.map((countData, index) => {
                        return (
                          <a
                            className="leave-type-card"
                            key={index}
                            style={{ cursor: "unset" }}
                          >
                            <div className="leave-summaryicons">
                              <div className="lt-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                              </div>
                             
                            </div>
                            <div className="lt-num">{countData?.WFHBalance}</div>
                            <div className="lt-name"> {countData?.WFHType}</div>
                           
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="notice-div d-flex">
              <div className="first-coll">
                <img src="images/org-img/leave/1.png" className="w-100" />
              </div>
              <div className="second-coll">
                <p></p>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="request-section">
                <div className="request-header">
                  <div class="req-icon-wrap">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                  </div>
                  <div>
                    <div class="request-title"> {T("Apply")} WFH</div>
                    <div class="request-sub">Fill in the details below and submit for manager approval</div>
                  </div>
                </div>
                 <div className="request-body">
                <div className="applyleaveform">
                  <form onSubmit={requestWfhForm.handleSubmit}>
                    <div className="row align-items-center">
                      <div className="col-xl-12">
                        <div className="row datediv">
                          <div className="mb-4 col-md-12">
                            <label className="form-label">
                               <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>Why you want Work From Home ?
                            </label>
                            <div className="position-relative">
                              <textarea
                                rows="6"
                                name="reason"
                                className={
                                  "form-control h-auto" +
                                  (requestWfhForm.errors.reason &&
                                    requestWfhForm.touched.reason
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={requestWfhForm.handleChange}
                                value={requestWfhForm.values.reason}
                                maxLength={500}
                                placeholder="Please enter any details that management should take into consideration"
                              ></textarea>
                              <div
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  position: "absolute",
                                  right: "27px",
                                  bottom: "13px",
                                  color:
                                    requestWfhForm.values.reason.length ===
                                      500
                                      ? "red"
                                      : "#555",
                                }}
                              >
                                {requestWfhForm.values.reason.length}/{500}
                              </div>
                            </div>
                            <div className="invalid-feedback">
                              {requestWfhForm.errors.reason &&
                                requestWfhForm.touched.reason
                                ? requestWfhForm.errors.reason
                                : null}
                            </div>
                          </div>
                          <div className="mb-4 col-md-6">
                            <label className="form-label"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>Start Date</label>
                            <div className="">
                              <input
                                type="date"
                                name="startDate"
                                onClick={(e) =>
                                  e.target.showPicker && e.target.showPicker()
                                }
                                className={
                                  "form-control" +
                                  (requestWfhForm.errors.startDate &&
                                    requestWfhForm.touched.startDate
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={(event) => {
                                  setStartDate(event.target.value);
                                  requestWfhForm.handleChange(event);
                                }}
                                value={requestWfhForm.values.startDate}
                                placeholder="Start Date"
                                min={minimumDate}
                              />
                            </div>
                            <div className="invalid-feedback">
                              {requestWfhForm.errors.endDate &&
                                requestWfhForm.touched.endDate
                                ? requestWfhForm.errors.endDate
                                : null}
                            </div>
                          </div>
                          <div className="mb-4 col-md-6">
                            <label className="form-label"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>End Date</label>
                            <div className="">
                              <input
                                type="date"
                                name="endDate"
                                onClick={(e) =>
                                  e.target.showPicker && e.target.showPicker()
                                }
                                className={
                                  "form-control" +
                                  (requestWfhForm.errors.endDate &&
                                    requestWfhForm.touched.endDate
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={(event) => {
                                  setEndDate(event.target.value);
                                  requestWfhForm.handleChange(event);
                                }}
                                value={requestWfhForm.values.endDate}
                                placeholder="End Date"
                                min={minimumDate}
                              />
                            </div>
                            <div className="invalid-feedback">
                              {requestWfhForm.errors.startDate &&
                                requestWfhForm.touched.startDate
                                ? requestWfhForm.errors.startDate
                                : null}
                            </div>
                            {dateError ? (
                              <span className="invalid-feedback">
                                {" "}
                                * End date should be greater than or equal
                                to start date.
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-xl-6">
                            {showHalfDay && (
                              <div className="d-flex mb-4">
                                <div className="form-check custom-checkbox checkbox-success">
                                  <input
                                    type="checkbox"
                                    name="isHalfDay"
                                    className={
                                      "form-check-input half-day-checkbox" +
                                      (requestWfhForm.errors.isHalfDay &&
                                        requestWfhForm.touched.isHalfDay
                                        ? " is-invalid"
                                        : "")
                                    }
                                    checked={checkedHalfDay}
                                    onChange={(e) =>
                                      setCheckedHalfDay(e.target.checked)
                                    }
                                    value={requestWfhForm.values.isHalfDay}
                                    style={{ borderColor: "#a49a9a" }}
                                  />
                                  <label
                                    className="form-check-label text-primary mb-3 sumh04"
                                    htmlFor="customCheckBox3"
                                  >
                                    Half Day ?
                                  </label>
                                </div>
                                {checkedHalfDay && (
                                  <div className="basic-form mx-3">
                                    <label className="switch2 ">
                                      <input
                                        type="checkbox"
                                        name="halfPreference"
                                        onChange={requestWfhForm.handleChange}
                                        value={
                                          requestWfhForm.values.halfPreference
                                        }
                                        disabled={
                                          checkedHalfDay == false
                                            ? true
                                            : false
                                        }
                                      />
                                      <span>
                                        <em></em>
                                        <strong></strong>
                                      </span>
                                    </label>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="col-xl-12 mb-4">
                            <button
                              type="submit"
                              className="savebtn-click m-0"
                              ref={scrolltoSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <WfhManagerReport />
          </div>
        </div>
      </div>

      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any Leave Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default WfhDashboard;
